
	import { Observer } from 'mobx-vue';
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import SnackbarBottom from './SnackbarBottom.vue';
	import HPAgentModule from '@/store/engine/modules/HPAgentModule';
	import Modal from '@/components/Modal.vue';

	@Observer
	@Component({ components: { SnackbarBottom, Modal } })
	export default class Updater extends Vue {
		private newSoftpaqAvailable = false;
		private downloading = false;
		private downloadingText = 'Downloading';
		private availableUpdateText = '';
		private agent?: HPAgentModule;
		private downloaded = false;
		private downloadedText = 'Downloaded';

		async mounted(): Promise<void> {
			this.agent = await this.$state.engine.agent;

			if (!this.agent) {
				throw new Error('Agent instance not found');
			}

			if (this.agent.agentStatus !== 0) {
				return;
			}

			const open = await this.agent.open();

			window.addEventListener('NewSoftpaqAvailable', this.OnNewSoftpaqAvailable);
			window.addEventListener('DownloadProgress', this.OnDownloadProgress);
			window.addEventListener('ReadyToInstall', this.OnReadyToInstall);
			window.addEventListener('NoUpdatesAvailable', this.NoUpdatesAvailable);
			window.addEventListener('OnDeviceAvailable', this.setupDevice);
			if (open === 2) {
				this.agent.checkUpdate();
			}
		}

		OnNewSoftpaqAvailable(e) {
			this.$state.agent.requiredUpdate = e.detail.isRequired;
			this.newSoftpaqAvailable = true;
			this.$state.agent.updateAvailable = true;
			this.availableUpdateText = `Available HP Agent update: ${e.detail.version}`;
		}

		OnDownloadProgress(e) {
			this.downloadingText = `Downloading (${e.detail.downloaded.toFixed(1)}/ 100)%`;
		}

		NoUpdatesAvailable(e) {
			this.$state.agent.requiredUpdate = false;
		}

		async OnReadyToInstall(e) {
			this.downloading = false;
			this.downloaded = true;
			await this.runInstaller();
		}

		download() {
			if (this.agent) {
				this.agent.triggerDownload();
				this.newSoftpaqAvailable = false;
				this.downloading = true;
				this.$state.agent.downloadingUpdate = true;
			}
		}

		async runInstaller() {
			if (this.agent) {
				this.agent.runInstaller();
			}

			for (let i = 0; i < 10; i++) {
				await new Promise((resolve) => setTimeout(resolve, 1000));
				this.downloadedText = `Downloaded, application will restart in: ${10 - i}`;
			}

			location.reload();
		}

		public async setupDevice() {
			if (!this.agent) {
				return;
			}

			const nonMocks = this.agent.devices.filter((device) => {
				return !device.model_id.includes('MOCK');
			});

			if (nonMocks.length > 0) {
				const tiger = this.agent.devices.find((device) => device.model_id.includes('TIGER'));
				if (tiger) {
					await this.$state.agent.setCurrentDevice(tiger);
					return;
				}

				await this.$state.agent.setCurrentDevice(nonMocks[0]);
			} else {
				await this.$state.agent.setCurrentDevice(this.agent.devices[0]);
			}
		}
	}
